import React from "react";
import { SeasonsWrapper } from "./Seasons.styled";

const Seasons = ({ seasons }) => {
  return (
    <SeasonsWrapper>
      <p>
        Seasons in total: <span>{seasons.length}</span>
      </p>
      <p>
        Episodes in total:
        <span>
          {seasons.reduce((acc, season) => acc + season.episodeOrder, 0)}
        </span>
      </p>
      {/* <SeasonList>
        {seasons.map((season) => (
          <div key={season.id} className="season-item">
            <div className="left">
              <p>Season {season.season}</p>
              <p>
                Episodes: <span>{season.number}</span>
              </p>
            </div>
            <div className="right">
              Aired:
              <span>{season.airdate}</span>
            </div>
          </div>
        ))}
      </SeasonList> */}
    </SeasonsWrapper>
  );
};

export default Seasons;
